<template>
    <div>
        <Breadcrumbs main="Vendors" title="Vendor List"/>
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">

              <div class="col-md-12">
                <div class="card">
                    <div hidden class="card-header">
                      <h5>Zero Configuration</h5>
                      <span>DataTables has most features enabled by default, so all you need to do to use it with your own tables is to call the construction function:<code>$().DataTable();</code>.</span><span>Searching, ordering and paging goodness will be immediately added to the table, as shown in this example.</span>
                    </div>

                    <div class="card-body">
                      <b-row>
                          <b-col md="4">

                              <b-input-group label-cols="" class="datatable-">
                                  <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                  <b-input-group-append>
                                      <b-button id="default-secondary" variant="secondary" :disabled="!filter" @click="filter = ''">Clear</b-button>
                                  </b-input-group-append>
                              </b-input-group>

                          </b-col>

                          <!-- <b-col md="3">
                            <b-form-group hidden label-cols="4" content-cols="6"  label="Selection" class="mb-0 datatable-select">
                                <b-form-select
                                  id="table-select-mode-select"
                                  v-model="selectMode"
                                  :options="modes"
                                  class="mb-3"
                                ></b-form-select>
                              </b-form-group>
                          </b-col> -->

                          <b-col md="4">
                              <b-form-group label-cols="4" content-cols="4" label="Per page" class="mb-0 datatable-select">
                                  <b-form-select style="width:100px" v-model="perPage" :options="pageOptions"></b-form-select>
                              </b-form-group>
                          </b-col>

                          <b-col md="4">
                            <div class="text-right">
                              <div class="form-group mb-0 mr-0"></div>
                              <a class="btn btn-primary mr-3 mb-2" v-b-modal.patient >
                                
                                <i class="icon-shopping-car"> </i> New Vendor</a
                              >
                              <a hidden class="btn btn-outline-primary mr-3 mb-2" v-b-modal.request >
                                
                                <i class="icon-user"> </i> Patient Request</a
                              >
                              <a  class="btn btn-outline-primary mr-3 " v-b-modal.importPatient >
                                <i class="icon-cloud-up"> </i> Import </a
                              >
                            </div>

                            <b-modal id="product" size="lg" ref="productModal" title="Add Products" ok-title="Done" class="theme-modal">
                                <template #modal-header>
                                    <h5>{{ vendor.business ? 'Add Products : '+vendor.business : viewProduct && editProduct ? 'View Products : '+viewProduct+', Edit Product : '+editProduct : 'View Products : '+viewProduct }} 
                                    <b-button class="ml-2" size="xs" @click="reset" pill variant="outline-danger"> Reset</b-button>
                                    </h5>
                                    
                                </template>

                                <form id="productForm" @submit.stop.prevent="checkSubmit" class="p-2 px-3">

                                    <figure v-if="productFile" class="b-image-wrapper image is-16by9 m-1">
                                        <b-img
                                            rounded
                                            :src="pro"
                                            style="width:100%"
                                            ratio="16by9"
                                        >
                                        </b-img>
                                    </figure>

                                    <div class="row form-group mt-2">
                                        <div class="col-sm-5 col-12">
                                            <label class="col-form-label" type="text" for="recipient-name">Product: <span class="txt-primary">( Name )</span></label>
                                                <b-form-input 
                                                autocomplete="0"
                                                autofocus 
                                                required 
                                                v-model="product.product"
                                                placeholder="Product Name">
                                            </b-form-input>
                                            
                                        </div>
                                        <div class="col-sm-4 col-6">
                                            <label class="col-form-label" type="text" for="recipient-name"> Image: <span class="txt-primary"></span></label>
                                            <b-form-file accept="image/jpeg, image/png" v-model="productFile" ></b-form-file>
                                        </div>
                                        <div class="col-sm-3 col-4">
                                          <label class="col-form-label" for="recipient-name">Type: <span class="badge badge-primary" @click="switchType"> swap </span></label>
                                            <b-form-select v-if="typeSelect" required v-model="product.type" :options="productType"></b-form-select>
                                            <b-form-input 
                                            v-else
                                            v-model="product.type" 
                                            placeholder="Type ">
                                            </b-form-input>
                                        </div>
                                    </div>
                                    <div class="row form-group mt-2">
                                        <div class="col-sm-3 col-4">
                                            <label class="col-form-label" type="text" for="recipient-name">Category: <span class="badge badge-primary" @click="switchCategory"> swap </span></label>
                                            <b-form-select v-if="categorySelect" required v-model="product.category" :options="productCategory"></b-form-select>
                                            <b-form-input 
                                                v-else
                                                v-model="product.category"
                                                placeholder="Category">
                                            </b-form-input>
                                        </div>
                                        <div class="col-sm-4 col-4">
                                          <label class="col-form-label" for="recipient-name">Tags: <span class="txt-primary">( Fresh, Leafy )</span></label>
                                          <b-form-input 
                                            v-model="product.tags" 
                                            placeholder="Tags ">
                                            </b-form-input>
                                        </div>
                                        <div class="col-sm-5 col-4">
                                            <label class="col-form-label" for="recipient-name">Details: <span class="txt-primary">( 4 pieces )</span></label>
                                            <b-form-input 
                                                required 
                                                v-model="product.details" 
                                                placeholder="Details ">
                                            </b-form-input>
                                        </div>
                                    </div>
                                    
                                    <div class="row form-group mt-2">
                                      <div class="col-sm-3 col-6">
                                            <label class="col-form-label" type="text" for="recipient-name">Price: <span class="txt-primary">{{ product.price && product.discount ? "("+ (product.price * ((100 - parseFloat(product.discount))/100)).toFixed(2)+")" : '' }} </span> </label>
                                            <b-form-input 
                                                type="number"
                                                required 
                                                step="0.1"
                                                v-model="product.price"
                                                placeholder="Price">
                                            </b-form-input>
                                        </div>
                                        <div class="col-sm-3 col-6">
                                          <label class="col-form-label" for="recipient-name">Discount: </label>
                                          <b-form-input 
                                            required 
                                            type="number"
                                            step="0.1"
                                            v-model="product.discount" 
                                            placeholder="Discount % ">
                                            </b-form-input>
                                        </div>

                                        <div class="col-sm-3 col-6">
                                          <label class="col-form-label" for="recipient-name">Margin: <span class="txt-primary">{{ product.price && product.margin ? product.discount ? "("+ ((product.price * ((100 - parseFloat(product.discount))/100)) * ((100 + parseFloat(product.margin))/100)).toFixed(2)+")" : "("+ (product.price * ((100 + parseFloat(product.margin))/100)).toFixed(2)+")" : '' }} </span></label>
                                          <b-form-input 
                                            required 
                                            type="number"
                                            step="0.01"
                                            v-model="product.margin" 
                                            @input="calcSelling"
                                            placeholder="Margin % ">
                                            </b-form-input>
                                        </div>

                                        <div class="col-sm-3 col-6">
                                          <label class="col-form-label" for="recipient-name">Selling: </label>
                                          <b-form-input 
                                            required 
                                            type="number"
                                            step="0.01"
                                            v-model="product.selling" 
                                            @input="calcMargin"
                                            placeholder="Selling  ">
                                            </b-form-input>
                                        </div>
                                    </div>
                                    <b-button block  type="submit" variant="primary">Submit</b-button>
                                </form>
                                <div class="px-3 py-2">
                                    <b-table
                                        show-empty
                                        ref="productTable"
                                        :items="allProducts"
                                        :fields="productfields"
                                        :sort-by.sync="sortProductBy"
                                        :current-page="currentProductPage"
                                        :per-page="perProductPage"
                                    >

                                        <template #cell(image)="row">
                                            <img :style="`width: 100px;${row.item.visible ? '' : 'opacity:0.55'}`" :src="row.item.image">
                                        </template>


                                        <template #cell(product)="row">
                                            {{ row.item.product }} <span class="badge badge-primary ml-2" v-if="row.item
                                            .discount > 0"> {{ row.item.discount }} % off</span>
                                            <br><b class="txt-primary"> {{ row.item.category }} </b>
                                            
                                            <br><span style="font-size:0.85rem;color:grey" class="txt-grey">{{ row.item.details }}</span>
                                        </template>
                                        

                                        <template #cell(price)="row">

                                            <span v-if="row.item.discount !== 0" style="font-weight:500" class="mr-1 txt-primary">
                                                <span class="mr-1 txt-dark" style="text-decoration:line-through;font-weight:400"> GH₵{{ formatPrice(row.item.price) }} </span>
                                                 GH₵{{ formatPrice( getDiscount(row.item.price, row.item.discount) ) }} 
                                            </span>
                                            <span class="txt-primary" style="font-weight:500" v-else>GH₵{{ formatPrice(row.item.price) }}</span>
                                            
                                        </template>

                                        <template #cell(margin)="row">
                                          {{ row.item.margin }} % 
                                          <span v-if="row.item.margin !== 0" style="font-weight:500" class="mr-1 txt-primary">
                                              <span v-if="row.item.discount !== 0" class="mr-1 txt-primary">- GH₵{{ formatPrice(getDiscount(row.item.price, row.item.discount) * ((100 + parseFloat(row.item.margin))/100) ) }} </span>
                                              <span v-else class="mr-1 txt-primary">- GH₵{{ formatPrice(row.item.price * ((100 + parseFloat(row.item.margin))/100)) }} </span>
                                          </span>

                                        </template>

                                        <template #cell(action)="row">

                                        <b-button variant="primary" @click="editproduct(row.item)" class="px-3 mr-2" size="sm"> <i class="icon-pencil"> </i>  </b-button>
                                        <b-button variant="danger" @click="delproduct(row.item)" class="px-3" size="sm"> <i class="icon-trash"> </i> </b-button>

                                        </template>
                                    </b-table>
                                    <p class="px-3">{{ allProducts.length }} items </p>

                                    <b-col md="6" class="my-1">
                                        <b-pagination
                                        v-model="currentProductPage"
                                        :total-rows="totalProductRows"
                                        :per-page="perProductPage"
                                        class="my-0"
                                        ></b-pagination>
                                    </b-col>
                                </div>
                            </b-modal>

                            <!-- patient form -->
                            <b-modal id="patient" ref="vendorModal" v-on:hide="resetVendor()" :title="`${( editVendor ? 'Edit Vendor : '+editVendor : 'Create New Vendor ')} `" ok-title="Done" class="theme-modal">

                              <template #modal-header>
                                <h5>{{ editVendor ? 'Edit Vendor : '+editVendor : 'Create New Vendor ' }} <b-button v-if="!(editVendor)" pill size="xs" type="reset" @click="resetVendor()" variant="outline-danger">Reset</b-button></h5>
                                
                              </template>
                              <!-- {{ patient }} -->
                              <p class="px-3">Kindly fill form to add a <b>Vendor</b>, add products <a class="badge badge-primary badge-md" v-b-modal.product> products <b>({{ allProducts.length ? allProducts.length : 0 }})</b> </a>
                               </p>
                              <!-- <p><b>#NB:</b> A 4-Digit <b>OTP verify Code</b> will be sent to <b>Patient's Tel.</b> </p> -->


                                <form id="vendorForm" @submit.stop.prevent="submitVendor" class="p-2 px-3">
                                    
                                    
                                    <figure v-if="dropFile || editVendor" class="b-image-wrapper image is-16by9 m-1">
                                        <b-img
                                            rounded
                                            :src="img"
                                            style="width:100%"
                                            ratio="16by9"
                                        >
                                        </b-img>
                                    </figure>

                                    <div class="row form-group mt-2">
                                        <div class="col-sm-6 col-6">
                                            <label class="col-form-label" type="text" for="recipient-name">Business: <span class="txt-primary">( Name )</span></label>
                                                <b-form-input 
                                                autocomplete="0"
                                                autofocus 
                                                required 
                                                v-model="vendor.business"
                                                placeholder="Business Name">
                                            </b-form-input>
                                            
                                        </div>
                                        <div class="col-sm-6 col-6">
                                            <label class="col-form-label" type="text" for="recipient-name">Cover image: <span class="txt-primary"></span></label>
                                            <b-form-file 
                                                :required="editVendor ? false : true"
                                                accept="image/jpeg, image/png" 
                                                v-model="dropFile" 
                                            ></b-form-file>
                                        </div>
                                    </div>

                                    

                                    <div class="row form-group mt-2">
                                        <!-- <div class="col-sm-6 col-6">
                                          <label class="col-form-label" for="recipient-name">Patient No:</label>
                                          <b-form-input required v-model="patient.no" type="text" placeholder="Patient No"></b-form-input>
                                        </div> -->
                                        <div class="col-sm-6 col-6">
                                          <label class="col-form-label" for="recipient-name">Type: <span class="txt-primary">( Meat, fruits and veges )</span></label>
                                          <b-form-input 
                                            required 
                                            v-model="vendor.type" 
                                            placeholder="Type ">
                                            </b-form-input>
                                        </div>
                                        <div class="col-sm-6 col-6">
                                            <label class="col-form-label" type="text" for="recipient-name">Categories: <span class="txt-primary">( Fish, Fruits )</span></label>
                                            <b-form-input 
                                                required 
                                                v-model="vendor.cat"
                                                placeholder="Categories">
                                            </b-form-input>
                                        </div>
                                    </div>

                                    
                                    
                                    <div class="row form-group mt-2">
                                        <div class="col-sm-3 col-4">
                                            <label class="col-form-label" type="text" for="recipient-name">CountryCode<span class="txt-primary"></span></label><br>
                                            <vue-country-code
                                                class=" p-1"
                                                
                                                @onSelect="onSelect"
                                                :enabledCountryCode="true"
                                                :preferredCountries="[ 'us', 'gb', 'gh','ng','ke']"
                                                >
                                            </vue-country-code>
                                        </div>
                                        <div class="col-sm-5 col-5">
                                            <label class="col-form-label" type="text" for="recipient-name">Country</label>
                                            <b-form-input 
                                                autocomplete="0"
                                                required 
                                                v-model="vendor.country.name"
                                                placeholder="Name">
                                            </b-form-input>
                                        </div>
                                        <div class="col-sm-4 col-3">
                                            <label class="col-form-label" type="text" for="recipient-name">Currency</label>
                                            <b-form-input 
                                                autocomplete="0"
                                                required 
                                                v-model="vendor.country.currency"
                                                placeholder="Currency">
                                            </b-form-input>
                                        </div>
                                    </div>
                                      

                                    <div class="row form-group mt-2">
                                        <!-- <div class="col-sm-6 col-6">
                                          <label class="col-form-label" for="recipient-name">Patient No:</label>
                                          <b-form-input required v-model="patient.no" type="text" placeholder="Patient No"></b-form-input>
                                        </div> -->
                                        <div class="col-sm-4 col-6">
                                          <label class="col-form-label" for="recipient-name">Contact: </label>
                                          <b-form-input 
                                            required 
                                            autocomplete="off"
                                            v-model="vendor.phone.tel" 
                                            type="tel" 
                                            placeholder="Business Contact ">
                                            </b-form-input>
                                        </div>
                                        <div class="col-sm-4 col-6">
                                          <label class="col-form-label" for="recipient-name">Staffname:</label>
                                          <b-form-input required v-model="vendor.staff_name" placeholder="Staff Name "></b-form-input>
                                        </div>
                                        <div class="col-sm-4 col-3">
                                            <label class="col-form-label p-2 " for="recipient-name">Accept Pickups:</label>
                                            <b-form-radio-group required :options="pickupOptions" v-model="vendor.isPickupAvailable" value-field="value" text-field="item">
                                            </b-form-radio-group>
                                        </div>
                                    </div>

                                    <!-- <b-form-group style="border:0" label="Individual radios" v-slot="{ ariaDescribedby }"> -->
                                      
                                    <!-- </b-form-group> -->

                                    <div class="row ">
                                      <div class="col-sm-5 col-6">
                                        <label class="col-form-label" for="recipient-name">Email: <span class="txt-primary">( For login )</span><span class="txt-primary">  </span></label>
                                        <b-form-input 
                                          required
                                          v-model="vendor.email" 
                                          autocomplete="off"
                                          type="email" 
                                          placeholder="Business Email">
                                        </b-form-input>
                                      </div>
                                      <div class="col-sm-4 col-6">
                                        <label class="col-form-label" for="recipient-name">Password:</label>
                                        <b-form-input :required="editVendor ? false : true" v-model="vendor.password" type="password" text-field="item" placeholder="Password">
                                        </b-form-input>
                                      </div>
                                      <div class="col-sm-3 col-6">
                                        <label class="col-form-label" for="recipient-name">Delivery Fee: </label>
                                        <b-form-input 
                                          required
                                          v-model="vendor.deliveryFee" 
                                          type="number" 
                                          placeholder="Delivery Fee">
                                        </b-form-input>
                                      </div>
                                    </div>
                                    
                                    
                                    <div class="row form-group mt-2">
                                      
                                      <div class="col-sm-4 col-4">
                                        <label class="col-form-label" for="recipient-name">Active:</label>
                                        <!-- <b-form-select required v-model="vendor.active" :options="statusOptions"></b-form-select> -->
                                        <b-form-radio-group required :options="statusOptions" v-model="vendor.active" value-field="value" text-field="item">
                                        </b-form-radio-group>
                                      </div>
                                      <div class="col-sm-4 col-4">
                                        <label class="col-form-label p-2 " for="recipient-name">Verified:</label>
                                        <b-form-radio-group required :options="verifiedOptions" v-model="vendor.verified" value-field="value" text-field="item">
                                        </b-form-radio-group>
                                      </div>
                                      <div class="col-sm-4 col-4">
                                        <label class="col-form-label p-2 " for="recipient-name">Free Delivery:</label>
                                        <b-form-radio-group required :options="freedeliveryOptions" v-model="vendor.freeDelivery" value-field="value" text-field="item">
                                        </b-form-radio-group>
                                      </div>
                                    </div>

                                    <div class="row form-group mt-2">
                                      <div class="col-sm-6 col-6">
                                        <label class="col-form-label" type="text" for="recipient-name">Location:  <a target="_blank" class="badge badge-primary" href="https://www.google.com/maps"> Google maps </a> </label>
                                        <b-form-input 
                                        autocomplete="0"
                                        required 
                                        v-model="vendor.locationName"
                                        placeholder="Business Location">
                                        </b-form-input>
                                      </div>
                                      <div class="col-sm-6 col-6">
                                        <label class="col-form-label" for="recipient-name">Location: <span class="txt-primary"> ( Lat, Lng ) </span></label>
                                        <b-form-input required v-model="vendor.loc" text-field="item" placeholder="Longitude">
                                        </b-form-input>
                                      </div>
                                      
                                    </div>

                                    <!-- <label class="col-form-label" for="message-text">Address: <span class="txt-primary">( Location / GPS Address )</span></label>
                                    <b-form-textarea
                                      id="textarea"
                                      rows="3"
                                      placeholder="Enter Address"
                                      v-model="patient.address"
                                    ></b-form-textarea> -->
                                    <b-button block  type="submit" :disabled="submitting" variant="primary">Submit</b-button>

                                    <!-- <label class="col-form-label" for="message-text">Message:</label>
                                    <b-form-textarea
                                      id="textarea"
                                      rows="3"
                                    ></b-form-textarea> -->
                                </form>
                            </b-modal>

                            <b-modal id="request" ref="requestModal" ok-title="Done" class="theme-modal">
                              <template #modal-header>
                                <h5>Patient Request Form </h5>
                              </template>
                              <div class="px-3">
                                <p>Kindly fill input below to request access to <b>patient's Data</b>, <br><b>#NB:</b> alert patient to accept / give you code.</p>
                                <h5>Criteria </h5>
                                <ol>
                                  <li>Patient No. or Contact</li>
                                  <li>Fullname and Date of Birth</li>
                                </ol>
                                <!-- <p><b>1. </b><br><b>2. </b></p> -->
                                <p>Request modes: <b>InApp:</b><i class="text-muted">via app</i> and <b>OTP:</b><i class="text-muted">one-time access code</i></p>
                              </div>

                              <form id="requestForm" @submit.stop.prevent="requestPatient" class="p-2 px-3">
                                    
                                    <div class="row form-group pb-2">
                                        
                                        <div class="col-sm-6 col-6">
                                          <label class="col-form-label" for="recipient-name">Patient No:</label>
                                          <b-form-input autofocus autocomplete="off" v-model="access.no" type="text" placeholder="Patient No"></b-form-input>
                                        </div>
                                        <div class="col-sm-6 col-6">
                                          <label class="col-form-label" for="recipient-name">Contact: </label>
                                          <b-form-input autocomplete="off" v-model="access.tel" type="tel" placeholder="Contact "></b-form-input>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row form-group pb-1">
                                        
                                        <div class="col-sm-7 col-6">
                                          <label class="col-form-label" type="text" for="recipient-name">Fullname:</label>
                                          <b-form-input autocomplete="off" v-model="access.fullname" placeholder="Fullname"></b-form-input>
                                          
                                        </div>
                                        <div class="col-sm-5 col-6">
                                          <label class="col-form-label" for="recipient-name">Date of Birth:</label>
                                          <b-form-input v-model="access.dob" type="date" placeholder="Patient No"></b-form-input>
                                        </div>
                                    </div>

                                    <div class="row ">
                                      <div class="col-sm-5 col-6">
                                        <label class="col-form-label" for="recipient-name">Request Mode:</label>
                                        <b-form-radio-group :options="requestOptions" v-model="access.request" value-field="value" text-field="item">
                                        </b-form-radio-group>
                                      </div>
                                      <div class="col-sm-7 col-6">
                                        <label class="col-form-label" for="recipient-name">Note:</label>
                                        <b-form-input v-model="access.note" type="tel" placeholder="Add note (Optional) "></b-form-input>
                                      </div>
                                    </div>

                                    <br>
                                    <br>
                                    <b-button v-if="requestLoading" block type="submit" variant="primary" disabled>
                                      <div class="loader-box" style="height:30px">
                                        <div class="loader-2"></div>
                                      </div>
                                    </b-button> 
                                    <b-button block v-else type="submit" variant="primary"> Request Access</b-button>
                                    <!-- <label class="col-form-label" for="message-text">Message:</label>
                                    <b-form-textarea
                                      id="textarea"
                                      rows="3"
                                    ></b-form-textarea> -->
                                </form>
                            </b-modal>

                            <!-- import patient -->
                            <b-modal id="importPatient" size="lg" title="Import Patients" ok-title="Ok" class="theme-modal">
                              <h5>Choose an Excel file</h5>
                              <p>Choose a <b> .csv, .xls, .xlsx </b> format. File should not exceed <b>0.7MB</b>  must contain not more than <b>3000 records</b></p>
                              <br>
                              <h5>Data presentation below</h5>

                              <table class="table ">
                                <thead>
                                  <th>Patient No</th>
                                  <th>Name</th>
                                  <th>Dob</th>
                                  <th>Gender</th>
                                  <th>Contact</th>
                                  <th>Email</th>
                                  <th>Status</th>
                                  <th></th>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td class=""> <i>PT0001</i></td>
                                    <td> <i>John Doe</i></td>
                                    <td> <i>1990-01-01</i></td>
                                    <td> <i>Male</i></td>
                                    <td> <i>0200000001</i></td>
                                    <td> <i>john.doe@email.com</i></td>
                                    <td> <i>Inactive</i></td>
                                    <td> <i></i></td>
                                  </tr>
                                  <tr>
                                    <td class=""> <i>PT0002</i></td>
                                    <td> <i>John Public</i></td>
                                    <td> <i>1990-01-01</i></td>
                                    <td> <i>Male</i></td>
                                    <td> <i>0200000001</i></td>
                                    <td> <i></i></td>
                                    <td> <i>Active</i></td>
                                    <td> <i></i></td>
                                  </tr>
                                </tbody>
                              </table>
                              <br>
                              <div class="form-group">
                                <h5>Upload Excel file</h5>
                                <vue-dropzone id="singledropzone" :options="singledropzoneOptions" class="dropzone digits" v-on:vdropzone-sending="sendingEvent">                                
                                </vue-dropzone>
                              </div>
                            </b-modal>

                            <!-- view vendor -->
                            <b-modal id="viewVendor" ref="viewvendorModal" :title="'View Vendor : '+viewVendor.business" ok-title="Ok" class="theme-modal">
                              <b-table stacked :fields="viewVendorfields" :items="[viewVendor]">

                                <template #cell(coverImage)="row">
                                    <figure v-if="row.item.coverImage" class="b-image-wrapper image is-16by9 m-1">
                                        <a :href="row.item.coverImage" target="_blank">
                                            <b-img
                                                rounded
                                                :src="row.item.coverImage"
                                                style="width:40%;"
                                            >
                                            </b-img>
                                        </a>
                                    </figure>
                                </template>

                                <template #cell(active)="row">
                                    <a v-b-tooltip.hover @click="status(row.item)" title="Click to change status" :class="`btn ${ (row.item.active ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                      {{ (row.item.active ? 'acive' : 'inactive') }}
                                    </a>
                                </template>

                                <template #cell(business)="row">
                                  <!-- <div class="txt-primary">
                                  {{ row.item.business }}
                                  </div> -->
                                    <span style="font-weight:500;" class="txt-primary">
                                        {{ row.item.business }} 
                                    </span>
                                    <br>
                                    <span v-b-tooltip.hover title="View location" @click="loc(row.item)" style="font-size:0.8rem;color:;"> {{ row.item.locationName }} </span>
                                </template>

                                <template #cell(categories)="row">
                                    <span class="txt-primary" style="font-weight:500">
                                        {{ row.item.categories.join(", ") }}
                                    </span>
                                </template>

                                <template #cell(access)="row">
                                    <div v-b-tooltip.hover :class="`btn ${ (row.item.access[0].status ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`" :title="row.item.access[0].type+' : '+new Date(row.item.access[0].updatedAt).toDateString()">
                                    {{ (row.item.access[0].status ? 'granted' : 'pending') }}
                                    </div>
                                </template>

                                <template #cell(email)="row">
                                  <a style="font-weight:500" :href="`mailto:${row.item.email}`" class="txt-primary">
                                      {{ row.item.email }}
                                    </a>
                                </template>

                                <template #cell(phone)="row">

                                    <a style="font-weight:500" :href="`tel:${row.item.phone.countryCode+row.item.phone.tel}`" class="txt-primary">
                                        {{ row.item.phone.countryCode+row.item.phone.tel }}
                                    </a>
                                </template>

                                <template #cell(ratings)="row">
                                    <span style="font-weight:500" class="txt-primary">
                                        {{ row.item.ratings.length > 0 ? parseFloat(row.item.ratings.reduce((a, b) => a + b, 0) / row.item.ratings.length).toFixed(1) : 0  }}

                                    </span>
                                </template>

                                <template #cell(available)="row">
                                    <div v-b-tooltip.hover :class="`btn ${ (row.item.available ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                        {{ (row.item.available ? 'Yes' : 'No') }}
                                    </div>
                                </template>

                                <template #cell(isPickupAvailable)="row">
                                    <div v-b-tooltip.hover :class="`btn ${ (row.item.isPickupAvailable ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                        {{ (row.item.isPickupAvailable ? 'Yes' : 'No') }}
                                    </div>
                                </template>

                                <template #cell(freeDelivery)="row">
                                    <div v-b-tooltip.hover :class="`btn ${ (row.item.freeDelivery ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                        {{ (row.item.freeDelivery ? 'Yes' : 'No') }}
                                    </div>
                                </template>

                                <template #cell(verified)="row">
                                    <a  @click="verify(row.item)" :class="`btn ${ (row.item.verified ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                      {{ (row.item.verified ? 'Verified' : 'not verified') }}
                                    </a>
                                </template>

                                <template #cell(createdAt)="row">
                                      {{ new Date(row.item.createdAt).toDateString().substr(4) }}
                                </template>

                              </b-table>
                            </b-modal>

                            

                            <!-- code -->
                            <b-modal id="enterCode" ref="enterCodeModal" ok-title="Ok" class="theme-modal">

                              <template #modal-header>
                                <h5>{{ 'Enter OTP Code : '+codeData.fullname }} </h5>
                                
                              </template>
                              <div class="px-3">
                                <p>Kindly enter <b>4-Digit</b> access code that was sent to patient's Device, <br><b>#NB:</b> alert patient to accept / give you code.</p>
                              </div>

                              <form id="codeForm" @submit.stop.prevent="submitCode" class="p-2 px-3">
                                  
                                  <div class="h4 text-center" type="text" for="code">OTP Access Code:</div>
                                  <div class="form-group">
                                    <b-form-input 
                                    autofocus 
                                    autocomplete="off"
                                    required 
                                    v-model="codeData.code" 
                                    maxlength="4"
                                    style="font-size: 1.8rem;padding: 35px;text-align: center;width: 50%;margin: auto;letter-spacing: 10px;"
                                    ></b-form-input>
                                  </div>

                                    <br>
                                  <b-button block  type="submit" variant="primary">Submit</b-button>
                              </form>
                            </b-modal>

                            <!-- add comment -->
                            <b-modal id="addComment" ref="addCommentModal" :title="`Add Comment : ${comment.name}`" ok-title="Ok" class="theme-modal">

                              <template #modal-header>
                                <h5>{{ comment.editComment ? 'Edit Comment : '+comment.editComment : 'Add Comment : '+comment.name }} </h5>
                                
                              </template>

                              <form id="patientForm" @submit.stop.prevent="submitComment" class="p-2 px-3">
                                  
                                  <label class="col-form-label" type="text" for="recipient-name">Title:</label>
                                  <b-form-input required v-model="comment.title" placeholder="title"></b-form-input>

                                  <label class="col-form-label" for="">Comment</label>
                                  <b-form-textarea
                                    id="textarea"
                                    v-model="comment.body"
                                    placeholder="Enter comment..."
                                    rows="3"
                                    max-rows="6"
                                  ></b-form-textarea>
                                    <br>
                                  <b-button block  type="submit" variant="primary">Submit</b-button>
                              </form>
                            </b-modal>

                            <b-modal id="viewComment" size="lg" ref="viewCommentModal" :title="'View Comment : '+comment.name" ok-title="Ok" class="theme-modal">
                              <b-table
                                show-empty
                                ref="Table"
                                :items="comments"
                                :fields="commentfields"
                                :filter="filter"
                                :current-page="currentPage"
                                :per-page="perPage"
                                @filtered="onFiltered"
                                @row-selected="onRowSelected"
                              >
                                <template #cell(body)="row">
                                    <u class="txt-primary"> {{ row.item.title }} </u>
                                    <p> {{ row.item.body }} </p>
                                </template>
                                

                                <template #cell(date)="row">
                                      {{ new Date(row.item.createdAt).toDateString().substr(4) }}
                                </template>

                                <template #cell(action)="row">

                                  <b-button variant="primary" @click="editcomment(row.item)" class="px-3 mr-2" size="sm"> <i class="icon-pencil"> </i>  </b-button>
                                  <b-button variant="danger" @click="delcomment(row.item)" class="px-3" size="sm"> <i class="icon-trash"> </i> </b-button>

                                </template>
                              </b-table>
                            </b-modal>

                          </b-col>
                      </b-row>
                      <b-modal id="orderModal" size="lg" ref="orderModal" :title="'View Orders : '+orderTitle" ok-title="Ok" class="theme-modal">
                              <b-table
                                show-empty
                                ref="orderTable"
                                :items="allOrders"
                                :fields="orderfields"
                                :per-page="perOrderPage"
                              >
                                <template #cell(vendor)="row">
                                  <a v-b-tooltip.hover :title="`Call ${row.item.vendor}`" style="font-weight:500"  class="txt-primary" :href="`tel:${row.item.vendorPhone ? row.item.vendorPhone.countryCode+row.item.vendorPhone.tel : ''}`">
                                    {{ row.item.vendor }}
                                  </a>
                                </template>

                                <template #cell(status)="row">
                                  <div :class=" (row.item.orderDelivered !== null ? 'btn-success my-2 btn-xs btn-pill' : row.item.cancelled ? 'btn-danger my-2 btn-xs btn-pill' : row.item.confirmed == null ? 'btn-warning my-2 btn-xs btn-pill' : ( row.item.courierAssigned || row.item.courierDelivering ? 'btn-info my-2 btn-xs btn-pill' : 'btn-light my-2 btn-xs btn-pill'))">{{ row.item.status }}</div>
                                </template>

                                <template #cell(userName)="row">
                                  <a v-b-tooltip.hover :title="`Call ${row.item.userName}`" style="font-weight:500" :href="`tel:${row.item.user.countryCode+row.item.user.tel}`" class="txt-primary">
                                    {{ row.item.userName }}
                                  </a>
                                </template>

                                <template #cell(orderNo)="row">
                                    <b v-b-tooltip.hover class="txt-dark" :title="row.item.orderNo"> {{ row.item.orderNo.split("-")[0] }} </b>
                                    <!-- <p> {{ row.item.body }} </p> -->
                                </template>

                                <template #cell(totalPrice)="row">
                                  <div  style="font-weight:500"  class="txt-primary" >
                                    {{ row.item.totalPrice.toFixed(2) }}
                                  </div>
                                </template>

                                <template #cell(deliveryFee)="row">
                                  <div  style="font-weight:500"  class="txt-primary" >
                                    {{ row.item.deliveryFee == 0 ? 'FREE' : row.item.deliveryFee.toFixed(2) }}
                                  </div>
                                </template>

                                <template #cell(createdAt)="row">
                                      {{ new Date(row.item.createdAt).toDateString().substr(4) }}
                                </template>

                                <template #cell(action)="row">

                                  <b-button variant="primary" @click="vieworder(row.item)" class="px-3 mr-2" size="sm"> <i class="icon-eye"> </i>  </b-button>
                                  <!-- <b-button variant="primary" @click="editcomment(row.item)" class="px-3 mr-2" size="sm"> <i class="icon-pencil"> </i>  </b-button> -->
                                  <!-- <b-button variant="danger" @click="delcomment(row.item)" class="px-3" size="sm"> <i class="icon-trash"> </i> </b-button> -->

                                </template>
                              </b-table>
                            </b-modal>

                            <b-modal id="viewOrdersDetail" ref="viewOrdersDetail" :title="`View Order Details : ${viewOrderDetails ? viewOrderDetails.orderNo : ''}`" ok-title="Ok" class="theme-modal">
                              <b-table stacked :fields="orderdetailsfields" :items="[viewOrderDetails]">

                                <template #cell(vendor)="row">
                                  <a v-b-tooltip.hover :title="`Call ${row.item.vendor}`" style="font-weight:500"  class="txt-primary" :href="`tel:${row.item.vendorPhone ? row.item.vendorPhone.countryCode+row.item.vendorPhone.tel : ''}`">
                                    {{ row.item.vendor }}
                                  </a>
                                </template>

                                <template #cell(status)="row">
                                  <span :class=" (row.item.orderDelivered !== null ? 'btn-success my-2 btn-xs btn-pill' : row.item.cancelled ? 'btn-danger my-2 btn-xs btn-pill' : row.item.confirmed == null ? 'btn-warning my-2 btn-xs btn-pill' : ( row.item.courierAssigned || row.item.courierDelivering ? 'btn-info my-2 btn-xs btn-pill' : 'btn-light my-2 btn-xs btn-pill'))">{{ row.item.status }}</span>
                                </template>

                                <template #cell(userName)="row">
                                  <a v-b-tooltip.hover :title="`Call ${row.item.userName}`" style="font-weight:500" :href="`tel:${row.item.user.countryCode+row.item.user.tel}`" class="txt-primary">
                                    {{ row.item.userName }}
                                  </a>
                                </template>

                                <template #cell(orderNo)="row">
                                    <b v-b-tooltip.hover class="txt-dark" :title="row.item.orderNo"> {{ row.item.orderNo.split("-")[0] }} </b>
                                    <!-- <p> {{ row.item.body }} </p> -->
                                </template>

                                <!-- <template #cell(totalActualPrice)="row">
                                  <div  style="font-weight:500"  class="txt-" >
                                    {{ row.item.totalActualPrice.toFixed(2) }}
                                  </div>
                                </template> -->

                                <template #cell(items)="row">
                                  <p v-for="pro in row.item.items" :key="pro.id">{{ pro.unit+' x '+pro.product+' x '+(pro.discount > 0 ? ((100-pro.discount) * pro.price/100).toFixed(2)+' - ('+pro.discount+'%) off' : pro.price.toFixed(2))+' = '+pro.total }}</p>
                                </template>

                                <template #cell(totalPrice)="row">
                                  <div  style="font-weight:500"  class="txt-primary" >
                                    {{ row.item.totalPrice.toFixed(2) }}
                                  </div>
                                </template>

                                <template #cell(deliveryFee)="row">
                                  <div  style="font-weight:500"  class="txt-primary" >
                                    {{ row.item.deliveryFee == 0 ? 'FREE' : row.item.deliveryFee.toFixed(2) }}
                                  </div>
                                </template>
                                
                                <template #cell(total)="row">
                                  <div  style="font-weight:500"  class="txt-" >
                                    {{ row.item.total.toFixed(2) }}
                                  </div>
                                </template>

                                <template #cell(courier)="row">
                                  <div  style="font-weight:500"  class="txt-primary" >
                                    {{ row.item.courier }}
                                  </div>
                                </template>

                                <template #cell(confirmed)="row">
                                      {{ row.item.confirmed ? new Date(row.item.confirmed).toGMTString() : '' }}
                                </template>

                                <template #cell(courierAssigned)="row">
                                      {{ row.item.courierAssigned ? new Date(row.item.courierAssigned).toGMTString() : '' }}
                                </template>

                                <template #cell(courierDelivering)="row">
                                      {{ row.item.courierDelivering ? new Date(row.item.courierDelivering).toGMTString() : '' }}
                                </template>

                                <template #cell(orderDelivered)="row">
                                      {{ row.item.orderDelivered ? new Date(row.item.orderDelivered).toGMTString() : '' }}
                                </template>

                                <template #cell(createdAt)="row">
                                      {{ new Date(row.item.createdAt).toGMTString() }}
                                </template>
                              </b-table>
                            </b-modal>

                    <!-- {{ selected }} -->
                      <div class="table-responsive datatable-vue">
                        <b-table
                          show-empty
                          ref="selectableTable"
                          :items="items"
                          :fields="tablefields"
                          :select-mode="selectMode"
                          :sort-by.sync="sortBy"
                          selectable
                          :filter="filter"
                          :current-page="currentPage"
                          :per-page="perPage"
                          @filtered="onFiltered"
                          @row-selected="onRowSelected"
                        >
                          <template #cell(action)="row">
                            <!-- <b-button size="sm" @click="row.toggleDetails" class="mr-2 ">
                              {{ row.detailsShowing ? 'Hide' : 'Show'}} Details
                            </b-button> -->
                            <b-dropdown text="more" size="sm" left class="mx-2" menu-class="dropdown-content" variant="primary">
                              <b-dropdown-item @click="orders(row.item)">Orders</b-dropdown-item>
                              <b-dropdown-item @click="products(row.item.business)">Products</b-dropdown-item>
                              <b-dropdown-item @click="couriers(row.item.business)">Couriers</b-dropdown-item>
                              <b-dropdown-item @click="edit(row.item)">Edit</b-dropdown-item>
                              <b-dropdown-item @click="view(row.item)">View </b-dropdown-item>
                              <!-- <b-dropdown-item v-if="row.item.access[0].status" @click="addcomment(row.item)">Add comment</b-dropdown-item> -->
                              <!-- <b-dropdown-item v-if="row.item.access[0].status" @click="viewcomment(row.item.fullname, row.item.tel)">View comment</b-dropdown-item> -->
                              <b-dropdown-divider></b-dropdown-divider>
                              <b-dropdown-item @click="del(row.index)">Delete </b-dropdown-item>
                          </b-dropdown>
                          </template>

                          <template #cell(business)="row">
                            <!-- <a :class="`btn ${ row.item.status (row.item.status == 'active' ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`" @click="status(row.item.status)">
                                
                              {{ row.item.status }}  </a @click="status(row.item.access[0])"
                              > -->
                              <span @click="view(row.item)" style="font-weight:500;" class="txt-primary">
                                {{ row.item.business }} 
                              </span>
                              <br>
                              <a class="txt-dark" target="_blank" :href="`https://www.google.com/maps/search/${row.item.location.coordinates[0]},${row.item.location.coordinates[1]}?entry=tts`" v-b-tooltip.hover title="View location" @click="loc(row.item)" style="font-size:0.8rem;color:;"> {{ row.item.locationName }} </a>
                          </template>

                          <template #cell(status)="row">
                            <!-- <a :class="`btn ${ row.item.status (row.item.status == 'active' ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`" @click="status(row.item.status)">
                                
                              {{ row.item.status }}  </a @click="status(row.item.access[0])"
                              > -->
                              <div v-b-tooltip.hover @click="status(row.item)" title="Click to change status" :class="`btn ${ (row.item.status == 'Active' ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                {{ row.item.status }}
                              </div>
                          </template>

                          <template #cell(ready)="row">
                            <!-- <a :class="`btn ${ row.item.status (row.item.status == 'active' ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`" @click="status(row.item.status)">
                                
                              {{ row.item.status }}  </a @click="status(row.item.access[0])"
                              > -->
                              <div v-b-tooltip.hover title="Online status" :class="`btn ${ (row.item.ready == 'Yes' ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                {{ row.item.ready }}
                              </div>
                          </template>

                          <template #cell(profile)="row">
                              <a v-b-tooltip.hover @click="verify(row.item)" :title="row.item.profile == 'Not verified' ? 'Click to verify' : ''" :class="`btn ${ (row.item.profile == 'Verified' ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                      {{ row.item.profile }}
                                    </a>
                          </template>
                    

                          <template #cell(dob)="row">
                            <span v-if="row.item.dob" v-b-tooltip.hover class="txt-primary" :title="new Date(row.item.dob).toDateString().substr(4)"> {{ calculateAge(row.item.dob) }} years </span>
                          </template>

                          <template #cell(email)="row">

                              <a style="font-weight:500" :href="`mailto:${row.item.email}`" class="txt-primary">
                                {{ row.item.email }}
                             </a>
                          </template>

                          <template #cell(phone)="row">

                            <a style="font-weight:500" :href="`tel:${row.item.phone.countryCode+row.item.phone.tel}`" class="txt-primary">
                                {{ row.item.phone.countryCode+row.item.phone.tel }}
                              </a>
                          </template>

                          <template #cell(rate)="row">

                            <span style="font-weight:500" class="txt-primary">
                              {{ row.item.rate }}

                            </span>
                          </template>

                          <template #cell(createdAt)="row">
                                {{ row.item.createdAt ? new Date(row.item.createdAt).toDateString().substr(4) : '' }}
                          </template>
                        </b-table>
                        
                      </div>

                      <p>{{ items.length }} items </p>

                      <b-col md="6" class="my-1">
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="totalRows"
                          :per-page="perPage"
                          class="my-0"
                        ></b-pagination>
                      </b-col>
                      


                    </div>

                </div>
              </div>

            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import axios from 'axios'
import moment from 'moment'

export default {
  data(){
    return{
      singledropzoneOptions:{
          url:"http://localhost:8080/uploadpatient",
          thumbnailWidth: 150,
          maxFiles:1,
          maxFilesize: 0.7,
          addRemoveLinks: true,
          dictDefaultMessage:"<i class='icon-cloud-up'></i><h6>Drop file here or click to upload.</h6><span>( Selected file is <strong>uploaded</strong> imediately after selection.)</span>"
      },
      img: '',
      pro: '',
      dropFile: null,
      productFile: null,
      editVendor: false,
      access: {
        no: '',
        tel: '',
        fullname: '',
        dob: '',
        note: '',
        request: 'OTP'
      },
      requestLoading: false,
      patient: {
        fullname: '',
        dob: '',
        gender: '',
        tel: '',
        email: '',
        address: ''
      },
      product: {
        product: '',
        category: null,
        tags: '',
        image: '',
        price: 0,
        margin: 0,
        selling: 0,
        discount: 0,
        type: null,
        details: '',
      },
      viewOrderDetails: null,
      viewCourier: null,
      viewProduct: null,
      editProduct: null,
      allProducts: [],
      allCouriers: [],
      submitting: false,
      orderTitle: '',
      allOrders: [],
      vendor: {
        business: '',
        staff_name: '',
        isPickupAvailable: '',
        cat: '',
        email: '',
        password: '',
        phone: {
            countryCode: '',
            tel: ''
        },
        country: {
            name: '',
            currency: '',
            code: ''
        },
        type: '',
        freeDelivery: '',
        locationName: '',
        loc: '',
        deliveryFee: 0,
        verified: '',
        active: null,
        address: ''
      },
      viewVendor: {},
      comment: {
        editComment: false,
        title: '',
        body: '',
        name:'',
        tel: '',
        patientno: '',
        id: ''
      },
      categorySelect: true,
      typeSelect: true,
      codeData: {},
      statusOptions: [
        //   { value: null, text: 'Select ' },
        { value: true, item: 'Yes' },
        { value: false, item: 'No' }
      ],
      verifiedOptions: [
        //   { value: null, text: 'Select ' },
        { value: true, item: 'Yes' },
        { value: false, item: 'No' }
      ],  
      freedeliveryOptions:[
        { value: true, item: 'Yes' },
        { value: false, item: 'No' }
      ],
      pickupOptions:[
        { value: true, item: 'Yes' },
        { value: false, item: 'No' }
      ],
      requestOptions:[
        { value:'InApp', item: 'InApp' },
        { value:'OTP', item: 'OTP' }
      ],
      
      productType: [
        { value: null, text: 'Select ' },
        { value: 'Item', text: 'Item' },
        { value: 'Pack', text: 'Pack' },
        { value: 'Bags', text: 'Bags' },
        { value: 'Per Weight', text: 'Per Weight' },
        { value: 'Per Volume', text: 'Per Volume' },
        { value: 'Per Box', text: 'Per Box' }
      ],
      productCategory: [
        { value: null, text: 'Select ' },
        { value: 'Fruit', text: 'Fruit' },
        { value: 'Vegetable', text: 'Vegetable' },
        { value: 'Meat', text: 'Meat' },
        { value: 'Fish', text: 'Fish' },
        { value: 'Poultry', text: 'Poultry' },
        { value: 'Diary', text: 'Diary' }
      ],
      tablefields: [
        { key: 'business', label: 'Business Name', sortable: true, },
        { key: 'status', label: 'Status', sortable: true, },
        { key: 'phone', label: 'Contact', sortable: false, },
        { key: 'type', label: 'Type', sortable: true, },
        { key: 'ready', label: 'Available', sortable: true, },
        // { key: 'locationName', label: 'Location', sortable: true, },
        { key: 'rate', label: 'Rated', sortable: true, },
        { key: 'profile', label: 'Profile', sortable: true, },
        { key: 'createdAt', label: 'Date', sortable: true, },
        { key: 'action', label: 'Action', sortable: false, },
      ],
      viewVendorfields: [
        { key: 'coverImage', label: 'Cover', sortable: true, },
        { key: 'business', label: 'Business Name', sortable: true, },
        { key: 'active', label: 'Status', sortable: true, },
        { key: 'phone', label: 'Contact', sortable: true, },
        { key: 'staff_name', label: 'Staff name', sortable: true, },
        { key: 'email', label: 'Email', sortable: true, },
        { key: 'type', label: 'Type', sortable: true, },
        { key: 'categories', label: 'Categories', sortable: true, },
        { key: 'available', label: 'Available', sortable: false, },
        // { key: 'locationName', label: 'Location', sortable: true, },
        { key: 'ratings', label: 'Rated', sortable: true, },
        { key: 'isPickupAvailable', label: 'Pickup available', sortable: true, },
        { key: 'freeDelivery', label: 'Free Delivery', sortable: true, },
        { key: 'deliveryFee', label: 'Delivery Fee', sortable: true, },
        { key: 'verified', label: 'Profile', sortable: true, },
        { key: 'createdAt', label: 'Date', sortable: true, },
      ],
      items: [],
      commentfields: [
        { key: 'body', label: 'Title & Comment', sortable: true, },
        { key: 'date', label: 'Date', sortable: true, },
        { key: 'action', label: 'Action', sortable: false, },
      ],
      productfields: [
        { key: 'image', label: 'Image', sortable: false, },
        { key: 'product', label: 'Product', sortable: true, },
        // { key: 'type', label: 'Type', sortable: true, },
        { key: 'price', label: 'Price', sortable: true, },
        { key: 'margin', label: 'Margin', sortable: true, },
        { key: 'action', label: 'Action', sortable: false, },
      ],
      orderfields: [
        { key: 'orderNo', label: 'Order No', sortable: false, },
        { key: 'vendor', label: 'Vendor', sortable: true, },
        { key: 'userName', label: 'Username', sortable: true, },
        { key: 'status', label: 'Status', sortable: true, },
        // { key: 'type', label: 'Type', sortable: true, },
        { key: 'totalPrice', label: 'Total Price', sortable: true, },
        { key: 'deliveryFee', label: 'Delivery', sortable: false, },
        { key: 'createdAt', label: 'Date', sortable: false, },
        { key: 'action', label: 'Action', sortable: false, },
      ],
      orderdetailsfields: [
        { key: 'orderNo', label: 'Order No', sortable: false, },
        { key: 'vendor', label: 'Vendor', sortable: true, },
        { key: 'userName', label: 'Username', sortable: true, },
        { key: 'items', label: 'Items', sortable: true, },
        // { key: 'totalActualPrice', label: 'Total Actual Price', sortable: true, },
        { key: 'totalPrice', label: 'Total Price', sortable: true, },
        { key: 'deliveryFee', label: 'Delivery', sortable: false, },
        { key: 'total', label: 'Total', sortable: false, },
        { key: 'courier', label: 'Courier', sortable: false, },
        { key: 'confirmed', label: 'Confirmed', sortable: false, },
        { key: 'courierAssigned', label: 'Courier Assigned', sortable: false, },
        { key: 'courierDelivering', label: 'Courier Delivering', sortable: false, },
        { key: 'orderDelivered', label: 'Order Delivered', sortable: false, },
        { key: 'paymentType', label: 'Payment Type', sortable: false, },
        { key: 'status', label: 'Status', sortable: true, },
        { key: 'createdAt', label: 'Date', sortable: false, },
        // { key: 'action', label: 'Action', sortable: false, },
      ],
      comments: [],
      modes: ['multi', 'single', 'range'],
      filter: null,
      sortBy: 'business',
      selectMode: 'multi',
      selected: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, 25, 50, 100],
      sortProductBy: 'product',
      currentProductPage: 1,
      totalProductRows: 1,
      totalCourierRows: 1,
      perProductPage: 5,
      perCourierPage: 5,
      totalOrderRows: 1,
      perOrderPage: 5,
    }
  },
  components: {
    vueDropzone: vue2Dropzone
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.tablefields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    }
  },
  created() {
    // watch and fetch
    this.$watch(
      () => this.$route.$params,
      () => {
        this.fetchData()
      },
      { immediate: true }

    )

  },
  watch: {
    dropFile() {
        if (this.dropFile !== null ){
            this.img = window.URL.createObjectURL(this.dropFile)    
        }

        if (this.dropFile == null) {
            window.URL.revokeObjectURL(this.img)
        }
    },
    productFile() {
        if (this.productFile !== null ){
            this.pro = window.URL.createObjectURL(this.productFile)    
        }

        if (this.productFile == null) {
            window.URL.revokeObjectURL(this.pro)
        }
    }
  },
  mounted() {
    // Set the initial number of items
    // this.totalRows = this.items.length
  },
  methods: {
    fetchData() {
      axios.get('/vendor')
        .then(response=>{
          //
          this.items = response.data
          // set
          // (function () {
            for (let index = 0; index < this.items.length; index++) {
                // const element = array[index];
                const rateLen = this.items[index].ratings.length

                if (rateLen > 0) {
                // sum ratings
                const rate = (this.items[index].ratings.reduce((a, b) => a + b, 0)) / rateLen
                // to 2 decimalplaces
                this.items[index].rate = parseFloat(rate.toFixed(1))

                // data.push(data[index])
                } else {
                  this.items[index].rate = 0
                }

                // status
                if (this.items[index].active) {
                  this.items[index].status = 'Active'
                } else {
                  this.items[index].status = 'Inactive'
                }

                // verified
                if (this.items[index].verified) {
                  this.items[index].profile = 'Verified'
                } else {
                  this.items[index].profile = 'Not verified'
                }

                // available
                if (this.items[index].available) {
                  this.items[index].ready = 'Yes'
                } else {
                  this.items[index].ready = 'No'
                }
            }
          // })()

          this.totalRows = this.items.length
        })
        .catch( e => {
          this.$swal({
            title:"Failed!",
            text:e.response.data,
            type:'error'
          });
        })
    },
    resetProduct() {
        this.allProducts = []
    },
    resetVendor() {
      this.editVendor = false
      this.dropFile = null
      this.img = null
      this.vendor.business = ''
      this.vendor.staff_name = ''
      this.vendor.isPickupAvailable = ''
      this.vendor.cat = ''
      this.vendor.email = ''
      this.vendor.password = ''
      this.vendor.type = ''
      this.vendor.freeDelivery = ''
      this.vendor.locationName = ''
      this.vendor.loc = ''
      this.vendor.deliveryFee = ''
      this.vendor.verified = ''
      this.vendor.active = ''
      this.vendor.address = ''
      this.vendor.phone = {
            countryCode: '',
            tel: ''
      }
      this.vendor.country = {
            name: '',
            currency: '',
            code: ''
      }
    },
    resetComment() {
      this.comment.editComment = false
      this.comment.patientno = ''
      this.comment.tel = ''
      this.comment.name = ''
      this.comment.title = ''
      this.comment.body = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    onRowSelected(items) {
      this.selected = items
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows()
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected()
    },
    sendingEvent (file, xhr, formData) {
        formData.append('paramName', 'some value or other');

        console.log(file)
    },
    successUpload(file, response){
        console.log(file, response)
    },
    failedUpload(file, message, xhr) {
        console.log(file, message, xhr)
    },
    requestPatient(){
      let url = '/patient/request'
      let method = axios.post
      // make uppercase
      this.access.no = this.access.no.toUpperCase()

      // validate
      if ((this.access.no == "" && this.access.tel == "") && (this.access.fullname == "" || this.access.dob == "")){

        this.$swal({
          title:"Warning!",
          text: "Kindly follow Critera for data input!",
          type:'warning'
        });

        return
      }

      this.requestLoading = true

      method(url, this.access)
      .then(response=>{
        //
        this.$swal({
          title:"Good job!",
          text: response.data,
          timer: 2000,
          type:'success'
        });

        //
        this.requestLoading = false
        
        //
        this.$refs.requestModal.hide()

        if (this.access.request == "OTP"){
          //
          this.code(this.access)
        }
        
        //
        this.fetchData()

      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });

         //
        this.requestLoading = false

      })

    },
    calcSelling() {
      this.product.selling = this.product.price && this.product.margin ? this.product.discount ? ((this.product.price * ((100 - parseFloat(this.product.discount))/100)) * ((100 + parseFloat(this.product.margin))/100)).toFixed(2) :  (this.product.price * ((100 + parseFloat(this.product.margin))/100)).toFixed(2) : 0
    },
    calcMargin() {
      this.product.margin = this.product.price && this.product.selling ? Math.round( ((this.product.selling/this.product.price - 1) * 100 ) * 100) / 100 : 0
    },
    submitVendor(){

      this.submitting = true

      let url
      let method

      if (this.editVendor) {
        url = '/vendor/'+this.editVendor
        method = axios.patch;

        //
        const loc = this.vendor.loc.split(',')
        this.vendor.location = [ parseFloat(loc[0]), parseFloat(loc[1]) ]
        this.vendor.categories = this.vendor.cat.split(',')

      } else {
        url = '/vendor'
        method = axios.post;
        //
        const loc = this.vendor.loc.split(',')
        this.vendor.location = [ parseFloat(loc[0]), parseFloat(loc[1]) ]
        this.vendor.categories = this.vendor.cat.split(',')

        if (this.allProducts.length > 0) {
            this.vendor.products = this.allProducts
        }
      }

      const cloudURL = 'https://api.cloudinary.com/v1_1/df8hf97qf/image/upload'
      // upload to cloudinary first
      if (this.dropFile || this.vendor.coverImage){
          //
          const formData = new FormData()
          formData.append('upload_preset', 'qwwhqvhe')
          formData.append('folder', 'vendors/')
          // formData.append('public_id', this.dropFile.name)
          formData.append('file', this.dropFile)

          // check for products
          if (this.vendor.products) {
            //
            const formData = new FormData()
            formData.append('upload_preset', 'qwwhqvhe')
            formData.append('folder', 'products/')
            // upload pro images
            this.vendor.products.forEach( product => {
                // set
                formData.append('file', product.imageFile)
                //
                fetch(cloudURL, {
                    method: 'POST',
                    body: formData
                }).then(async response=> {
                    
                    const data = await response.json()

                    if (!response.ok) {
                        const error = (data && data.message) || response.status
                        return Promise.reject(error)
                    }

                    //
                    product.image = data.secure_url
                    delete(product.imageFile)

                    console.log(product.image)
                    
                })
                
            });

          }

          // 
          if (this.vendor.coverImage && !this.dropFile) {
            //
            method(url, this.vendor)
                .then(response=>{
                    //
                    this.$swal({
                    title:"Good job!",
                    text: response.data,
                    type:'success'
                    });
                    
                    //
                    this.$refs.vendorModal.hide()
                    //
                    this.fetchData()
                    
                    this.submitting = false

                })
                .catch( e => {
                    this.$swal({
                    title:"Failed!",
                    text: e.response.data,
                    type:'error'
                    });

                    this.submitting = false
                })

            return
          }

          fetch(cloudURL, {
              method: 'POST',
              body: formData
          }).then(async response=> {
                
                const data = await response.json()

                if (!response.ok) {
                    const error = (data && data.message) || response.status
                    return Promise.reject(error)
                }

                //
                this.vendor.coverImage = data.secure_url

                method(url, this.vendor)
                .then(response=>{
                    //
                    this.$swal({
                    title:"Good job!",
                    text: response.data,
                    type:'success'
                    });
                    
                    //
                    this.$refs.vendorModal.hide()
                    //
                    this.submitting = false
                    //
                    this.fetchData()
                    

                })
                .catch( e => {
                    this.$swal({
                    title:"Failed!",
                    text: e.response.data,
                    type:'error'
                    });

                    this.submitting = false
                })

          })

      }

      
    },
    orders(data) {
        // modal
        this.$refs.orderModal.show()
        //
        this.orderTitle = data.business

        //
        axios.get('/order/'+data.business).then( response=>{

            //
            this.allOrders = response.data
            this.totalOrderRows = response.data.length

        }).catch(error=>{

            console.log(error.response.data)
        })

    },
    checkSubmit() {
      console.log('here')
      //
      if (this.viewProduct) {
        this.submitProduct()
      }
      else {
        this.pushProduct()
      }
    },
    pushProduct() {
        //
        const product = {}
        product.product = this.product.product
        product.category = this.product.category
        product.imageFile = this.productFile
        product.image = ''
        product.tags = this.product.tags
        product.price = parseFloat(this.product.price)
        product.discount = parseInt(this.product.discount)
        product.type = this.product.type
        product.details = this.product.details

        //
        this.allProducts.push(product)
        //
        this.productFile = null
        // this.product.product = ''
        // this.product.category = null
        // this.product.tags = ''
        // this.product.price = 0
        // this.product.discount = 0
        // this.product.type = null
        // this.product.details = ''
    },
    delproduct(row) {
      //
      // const index = this.allProducts.findIndex(pro => pro.product.includes(row.product))
      // this.allProducts.splice(index, 1)

      this.$swal({
				text:`Are you sure you want to delete ${row.product}'s request?`,
				showCancelButton: true,
				confirmButtonText: 'Yes',
        type:'error'
			}).then((result)=>{

        if(result.value){

          axios.delete('/product/'+this.viewProduct+'/'+encodeURIComponent(row.product)).then(response =>{
              //
              this.$swal({
                title:"Good job!",
                text: response.data,
                type:'success'
              });
              //
              this.products(this.product.business)

            }).catch( e => {
                this.$swal({
                  title:"Failed!",
                  text: e.response.data,
                  type:'error'
                });
            })
          }
        })
      
    },
    reset() {

      let pro = {}
      pro.product = ''
      pro.category = ''
      pro.image = ''
      pro.tags = ''
      pro.price = 0
      pro.margin = 0
      pro.discount = 0
      pro.type = ''
      pro.details = ''

      this.product.product = pro.product
      this.product.category = pro.category
      this.product.image = pro.image
      this.product.tags = pro.tags
      this.product.price = pro.price
      this.product.margin = pro.margin
      this.product.discount = pro.discount
      this.product.type = pro.type
      this.product.details = pro.details

      this.editProduct = null
      this.productFile  = null

    },
    editproduct(data){

      this.editProduct = data.product
      //
      let product = {}
      product.product = data.product
      product.category = data.category
      product.image = data.image
      product.tags = data.tags
      product.price = data.price
      product.margin = data.margin
      product.discount = data.discount
      product.type = data.type
      product.details = data.details

      this.product.product = product.product
      this.product.category = product.category
      this.product.image = product.image
      this.product.tags = product.tags.join(',')
      this.product.price = product.price
      this.product.margin = product.margin
      this.product.discount = product.discount
      this.product.type = product.type
      this.product.details = product.details
      
      //
      
    },
    products(business) {
        // modal
        this.$refs.productModal.show()
        //
        this.viewProduct = business

        //
        axios.get('/product/'+business).then( response=>{

            //
            this.allProducts = response.data
            this.totalProductRows = response.data.length

        }).catch(error=>{

            console.log(error.response.data)
        })

    },
    submitProduct() {

        //
        this.product.business = this.viewProduct
        // validate
        // if (this.allProducts.find(pro => pro.product.includes(this.product.product))) {
        //   return
        // }
        
        //
        const cloudURL = 'https://api.cloudinary.com/v1_1/df8hf97qf/image/upload'

        if (this.productFile){
          //
          const formData = new FormData()
          formData.append('upload_preset', 'qwwhqvhe')
          formData.append('folder', 'products/')
          // set
          formData.append('file', this.productFile)
          //
          fetch(cloudURL, {
              method: 'POST',
              body: formData
          }).then(async response=> {
                      
            const data = await response.json()

            if (!response.ok) {
                const error = (data && data.message) || response.status

                this.$swal({
                  title:"Failed!",
                  text: data.message,
                  type:'error'
                });

                return Promise.reject(error)
            }

            //
            this.product.image = data.secure_url
            delete(this.product.imageFile)
            this.product.price = parseFloat(this.product.price)
            this.product.discount = parseFloat(this.product.discount)
            this.product.tags = this.product.tags.split(',')

            console.log(this.product.image)
            //
            let url
            let method

            if (this.editProduct) {
              url = '/product/'+encodeURIComponent(this.editProduct)
              method = axios.patch;

            } else {
              url = '/product'
              method = axios.post;

            }
            //
            method(url, this.product).then(response =>{
              //
              this.$swal({
                title:"Good job!",
                text: response.data,
                type:'success'
              });
              //
              this.products(this.product.business)
            }).catch( e => {
                this.$swal({
                  title:"Failed!",
                  text: e.response.data,
                  type:'error'
                });
            })

          })
        
        } else {
          
          if (this.editProduct) {
            //
            axios.patch('/product/'+encodeURIComponent(this.editProduct), this.product).then(response =>{
              //
              this.$swal({
                title:"Good job!",
                text: response.data,
                type:'success'
              });
              //
              this.products(this.product.business)
              //
              this.editProduct = null

            }).catch( e => {
                this.$swal({
                  title:"Failed!",
                  text: e.response.data,
                  type:'error'
                });
            })
          }
        }     
            // });
        // }
    },
    submitProducts() {
        //
        const cloudURL = 'https://api.cloudinary.com/v1_1/df8hf97qf/image/upload'
        //
        if (this.products.length > 0) {
            this.products.forEach( product => {
                //
                const formData = new FormData()
                formData.append('upload_preset', 'qwwhqvhe')
                formData.append('folder', 'products/')
                // set
                formData.append('file', product.imageFile)
                //
                fetch(cloudURL, {
                    method: 'POST',
                    body: formData
                }).then(async response=> {
                    
                    const data = await response.json()

                    if (!response.ok) {
                        const error = (data && data.message) || response.status
                        return Promise.reject(error)
                    }

                    //
                    product.image = data.secure_url
                    delete(product.imageFile)

                    console.log(product.image)
                    
                })
                
            });
        }
    },
    couriers(business) {
        // modal
        this.$refs.courierModal.show()
        //
        this.viewCourier = business

        //
        axios.get('/courier/'+business).then( response=>{

            //
            this.allCouriers = response.data
            this.totalCourierRows = response.data.length

        }).catch(error=>{

            console.log(error.response.data)
        })

    },
    vieworder(data) {
        // modal
        this.$refs.viewOrdersDetail.show()
        //
        this.viewOrderDetails = data


    },
    edit(data) {
      // modal
      this.$refs.vendorModal.show()
      this.editVendor = data.business
      // form
      const vendor = {}
      vendor.business = data.business
      vendor.type = data.type
      vendor.categories = data.categories
      vendor.phone = data.phone
      vendor.email = data.email
      vendor.country = data.country
      vendor.staff_name = data.staff_name
      vendor.isPickupAvailable = data.isPickupAvailable
      vendor.active = data.active
      vendor.status = data.status
      vendor.verified = data.verified
      vendor.freeDelivery = data.freeDelivery
      vendor.location = data.location
      vendor.locationName = data.locationName
      vendor.deliveryFee = data.deliveryFee
      vendor.coverImage = data.coverImage
      
      
      this.img = data.coverImage
      this.vendor = vendor
      this.vendor.cat = vendor.categories.join(", ")
      this.vendor.loc = vendor.location.coordinates.join(",")

    },
    code(data){
      // modal
      this.$refs.enterCodeModal.show()

      this.codeData.fullname = data.fullname
      this.codeData.tel = data.tel
      this.codeData.dob = data.dob
      this.codeData.patientno = data.patientno
      this.codeData.no = data.no
      //
    },
    view(data){
      // modal
      this.$refs.viewvendorModal.show()

      this.viewVendor = data
      //
    },
    submitCode(){

      let url = '/patient/request/code'
      let method =  axios.post

      if (!this.codeData.code ) {
        return this.$swal({
          title:"Oops!",
          text: "Kindly enter access code!",
          type:'warning'
        });
      }

      method(url, this.codeData )
      .then(response=>{
        //
        this.$swal({
          title:"Good job!",
          text: response.data,
          type:'success'
        });

        //
        this.$refs.enterCodeModal.hide()
        //
        this.fetchData()
        //
        this.codeData = {}
        
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })

    },
    addcomment(data){
      // modal
      this.resetComment()
      this.$refs.addCommentModal.show()
      this.comment.name = data.fullname
      this.comment.tel = data.tel
      this.comment.patientno = data.patientno
      this.comment.title = ''
      this.comment.body = ''
      
    },
    editcomment(data){
      // modal
      this.$refs.addCommentModal.show()
      this.comment.editComment = this.comment.name
      this.comment.id = data._id
      this.comment.title = data.title
      this.comment.body = data.body
      
    },
    viewcomment(fullname, tel){
      // modal
      this.$refs.viewCommentModal.show()
      this.comment.tel = tel
      this.comment.name = fullname

      axios.get('/patient/comment/'+tel)
      .then(response=>{
        //
        this.comments = response.data
        
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })
    },
    delcomment(data) {

      this.$swal({
				text:`Are you sure you want to delete '${data.title}'?`,
				showCancelButton: true,
				confirmButtonText: 'Yes',
        type:'error'
			}).then((result)=>{

        if(result.value){

          axios.delete('/patient/comment/'+this.comment.tel+'/'+data._id)
            .then(response=>{
              //
              this.$swal({
                title:"Good job!",
                text: `'${data.title}' `+response.data,
                type:'success'
              });
              //
              this.viewcomment(this.comment.name, this.comment.tel)
            })
            .catch( e => {
              this.$swal({
                title:"Failed!",
                text: e.response.data,
                type:'error'
              });
          })
        }
      })
    },
    submitComment(){

      let url
      let method

      if (this.comment.editComment) {
        url = '/patient/comment/'+this.comment.editComment
        method = axios.patch;
      } else {
        url = '/patient/comment'
        method = axios.post;
      }

      method(url, { patient: { fullname: this.comment.name, tel: this.comment.tel }, title: this.comment.title, body: this.comment.body, id: this.comment.id} )
      .then(response=>{
        //
        this.$swal({
          title:"Good job!",
          text: response.data,
          type:'success'
        });

        //
        this.$refs.addCommentModal.hide()
        
        this.viewcomment(this.comment.name, this.comment.tel)
        //
        
        
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })

    },
    status(data) {
      //
      axios.post('/vendor/status', { business: data.business, phone: data.phone, status: data.active })
      .then(response=>{
        //
        this.$swal({
          title:"Good job!",
          text: response.data,
          type:'success'
        });
        //
        this.fetchData()
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })

    },
    verify(data) {
        if (data.verified) {
            return
        }
      //
      axios.post('/vendor/verify', { business: data.business, phone: data.phone })
      .then(response=>{
        //
        this.$swal({
          title:"Good job!",
          text: response.data,
          type:'success'
        });
        //
        this.fetchData()
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })

    },
    del(data) {

      this.$swal({
				text:`Are you sure you want to delete ${data.fullname}'s request?`,
				showCancelButton: true,
				confirmButtonText: 'Yes',
        type:'error'
			}).then((result)=>{

        if(result.value){

          axios.delete('/patient/request/'+data.patientno+'/'+data.access[0]._id)
            .then(response=>{
              //
              this.$swal({
                title:"Good job!",
                text: response.data,
                type:'success'
              });
              //
              this.fetchData()
            })
            .catch( e => {
              this.$swal({
                title:"Failed!",
                text: e.response.data,
                type:'error'
              });
          })
        }
      })
    },
    calculateAge(dob) { 
      //
      let now
      now = moment(new Date())
      const _dob = moment(dob)
      return now.diff(_dob, 'years')
    },
    formatPrice(price) {
        return price.toFixed(2)
    },
    getDiscount(price, disc) {
            return ((100 - disc)/100) * price;
    },
    onSelect({name, iso2, dialCode}) {
        // this.form.code = "+"+dialCode
        this.vendor.country.name = name.split("(")[0].trim()
        this.vendor.country.currency = dialCode == "233" ? iso2+"₵" : iso2
        this.vendor.country.code = "+"+dialCode
        this.vendor.phone.countryCode = "+"+dialCode
        console.log(name, iso2, dialCode);
    },
    switchCategory() {
        this.categorySelect = this.categorySelect ? false : true
    },
    switchType() {
        this.typeSelect = this.typeSelect ? false : true
    },
  }
}
</script>
<style scoped>
/* #patientForm .form-control {
 font-size: inherit;
} */

.table tr > td {
  color: rgba(43,43,43,.54);
}

.loader-box [class*="loader-"] {
    width: 30px;
    height: 30px;
}
</style>